module.exports = __webpack_public_path__ + "img/09b9f26.png";